import React, { Component } from 'react';
import { firebaseAuth, logComponentLoad, serverIp} from '../../../../config/constants.js'
import { Table, Button, Header, Card, Icon } from 'semantic-ui-react'
import * as UiConsts from '../../../../config/UiConstants'
import { checkAdminEmail } from '../algoliaDashboard/AlgoliaMiscUtils';
import { Link } from 'react-router-dom';
import axios from 'axios'

class ViewLargeProjectOrderEntry_options_card extends Component {
    constructor(props) {
        super(props);
        this.state = {
            order: '',
            loadingUser: true,
            loading: false,

            largeProjectItemOptions: [],
        }
    }

    componentDidMount() {
        firebaseAuth().onAuthStateChanged((user) => {

            if (user) {
                console.log("maddx241 user is:" + user.email);

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult);

                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    loading: false,
                    user: user,
                    uid: user.uid
                })
            }
        });

    }

    setAdminResult = (returnObject) => {
        // console.log("++++++ addx294 setAdminResult");
        // console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));

        //logComponentLoad(returnObject, "ViewLargeProjectOrderEntry_options");

        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
            loadingUser: false
        })

    }

    load_item_options = () => {
        // SEND CHECK TO SERVER

        this.setState({ loading: true })

        axios.post(serverIp + "large_project_items/getItemOptions", {
            apiKey: "ViewLargeProjectItem_header",
            enteredBy: this.props.user.email,
            largeProjectItemId: this.props.largeProjectItemId,
            optionType: this.props.optionType
        })
            .then((response) => {

                console.log("load_item_options reply"+JSON.stringify(response.data));

                if (response.data.result) {
                    console.log("true.. ");

                    this.setState({
                        loading: false,
                        largeProjectItemOptions: response.data.singleLargeProjectItemOptions
                    })

                    //alert(response.data.message);
                    //history.push("/dashboard/viewLargeProject/" + this.props.projectId);
                } else {
                    console.log("FAILED");
                    alert(response.data.message);
                }
            })
            .catch((error) => {
                console.log(error);
                alert("FAILED TO LOAD ITEMS");
                this.setState({
                    loading: false
                })
            });
    }



    render() {


        const tableRow = this.state.largeProjectItemOptions.length > 0
            ? this.state.largeProjectItemOptions.map((item, index) =>
                <Table.Row key={item.idlargeProjectItemOptions}>
                    <Table.Cell textAlign='left'> {item.idlargeProjectItemOptions} </Table.Cell>
                    <Table.Cell>{item.categoryOption}</Table.Cell>
                    <Table.Cell> <Link to={'/dashboard/editLargeProjectItem_option_value/'+ item.idlargeProjects+ '/' + item.idlargeProjectItemOptions}>{item.valueOption}</Link>  </Table.Cell>
                </Table.Row>)
            : ''

        const mainTable = this.state.largeProjectItemOptions.length > 0
        ? <Table striped>
        <Table.Header>
            <Table.Row>
                <Table.HeaderCell>#</Table.HeaderCell>
                <Table.HeaderCell>Item</Table.HeaderCell>
                <Table.HeaderCell>Value</Table.HeaderCell>
            </Table.Row>
        </Table.Header>

        <Table.Body>
            {tableRow}
        </Table.Body>

    </Table>
    :''

    
        const wholeUI = this.state.algoliaUser && this.state.algoliaUser.isAdmin
            ? <div>

                <Button color="teal" onClick={this.load_item_options} fluid>VIEW OPTIONS</Button>
                
                {mainTable}

            </div>
            : <h4>loading error a75</h4>

        return (this.state.loading === true ? <UiConsts.LoadingComponent /> :
            <div>

                {wholeUI}

            </div>
        )
    }
}

export default ViewLargeProjectOrderEntry_options_card;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjectOrderEntry/ViewLargeProjectOrderEntry_options_card.js